/** Strip all non-digits and cap at the 10-digit NANP length. */
export const cleanPhoneNumber = (value: string): string => value.replace(/\D/g, '').slice(0, 10);

/**
 * Format phone input progressively as the user types, e.g. "7757683827" -> "775-768-3827".
 * Handles partial input and caps at 10 digits via cleanPhoneNumber.
 */
export const formatPhoneNumberInput = (value: string): string => {
  const digits = cleanPhoneNumber(value);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};
